import React from "react";
import { Phone, Clock, Star, MapPin } from "lucide-react";
import { businessInfo } from "../mock";
import { Button } from "./ui/button";

const Hero = () => {
  return (
    <section id="top" className="relative min-h-[100svh] w-full overflow-hidden fire-bg">
      {/* Decorative smoke overlays */}
      <div
        className="absolute inset-0 opacity-40 pointer-events-none"
        style={{
          backgroundImage:
            "radial-gradient(circle at 80% 30%, rgba(255,50,50,0.35) 0%, transparent 35%), radial-gradient(circle at 15% 70%, rgba(220,31,45,0.45) 0%, transparent 40%)"
        }}
      />
      <div
        className="absolute inset-0 opacity-[0.04] pointer-events-none"
        style={{
          backgroundImage: "radial-gradient(circle at 1px 1px, white 1px, transparent 0)",
          backgroundSize: "24px 24px"
        }}
      />

      <div className="relative max-w-7xl mx-auto px-5 lg:px-8 pt-36 pb-20 lg:pt-44 lg:pb-28 grid lg:grid-cols-[1.1fr_0.9fr] gap-12 items-center">
        <div>
          <div className="fade-up inline-flex items-center gap-2 bg-red-950/40 backdrop-blur border border-red-600/40 text-red-200 text-xs font-bold tracking-widest uppercase px-3 py-1.5 rounded-full">
            <span className="w-2 h-2 rounded-full bg-green-400 animate-pulse" />
            Open 24 Hours · On Call Now
          </div>

          <h1 className="fade-up-delay-1 mt-5 font-extrabold tracking-tight text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-white">
            Locked Out? Lost Your Key?
            <br />
            <span className="text-fire">I'll Come To You.</span>
          </h1>

          <p className="fade-up-delay-2 mt-6 text-white text-lg lg:text-xl font-semibold italic max-w-xl leading-snug border-l-4 border-red-600 pl-4">
            {`\u201c${businessInfo.catchphrase}\u201d`}
          </p>

          <p className="fade-up-delay-2 mt-5 text-zinc-400 text-base lg:text-lg max-w-xl leading-relaxed">
            {businessInfo.description}
          </p>

          <div className="fade-up-delay-3 mt-8 flex flex-wrap gap-4">
            <Button asChild className="bg-brand-red text-white font-semibold h-14 px-7 text-base pulse-ring">
              <a href={`tel:${businessInfo.phoneRaw}`}>
                <Phone className="w-5 h-5 mr-2" />
                Call {businessInfo.phone}
              </a>
            </Button>
            <Button asChild variant="outline" className="h-14 px-7 text-base bg-white/5 border-yellow-500/40 text-yellow-300 hover:bg-yellow-500 hover:text-black hover:border-yellow-500 font-semibold">
              <a href="#pricing">See Pricing</a>
            </Button>
          </div>

          <div className="fade-up-delay-3 mt-10 grid grid-cols-3 gap-4 max-w-xl">
            <Stat icon={<Clock className="w-5 h-5" />} label="24/7" sub="Service" />
            <Stat icon={<Star className="w-5 h-5" />} label="5.0" sub="Yelp Rated" />
            <Stat icon={<MapPin className="w-5 h-5" />} label="Tri-State" sub="Coverage" />
          </div>
        </div>

        {/* Logo showcase */}
        <div className="hidden lg:flex justify-center items-center">
          <div className="relative">
            <div className="absolute inset-0 blur-3xl bg-red-600/30 rounded-full" />
            <img
              src={businessInfo.logoUrl}
              alt="1/2 Fast Mobile Keys logo"
              className="relative w-full max-w-md drop-shadow-[0_0_40px_rgba(220,31,45,0.7)]"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

const Stat = ({ icon, label, sub }) => (
  <div className="brand-card rounded-lg px-4 py-3">
    <div className="flex items-center gap-2 text-red-500">{icon}</div>
    <div className="text-white font-bold text-xl mt-1 leading-none">{label}</div>
    <div className="text-zinc-400 text-xs mt-1">{sub}</div>
  </div>
);

export default Hero;
